export { default } from './MultiIdioma';
